import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.scss';
import classNames from 'classnames';
export function PlotTile({ title, value, color }) {
    return (_jsxs("div", { className: styles.container, children: [_jsx("span", { className: styles.title, children: title }), _jsx("span", { className: classNames(styles.value, color === 'primary' ? styles.primaryText : styles.secondaryText), children: value })] }));
}
